import { createAction } from 'redux-actions';

export const createMigrateRequest = createAction('CREATE_MIGRATE_REQUEST');
export const createMigrateSuccess = createAction('CREATE_MIGRATE_SUCCESS');
export const createMigrateFail = createAction('CREATE_MIGRATE_FAIL');
